/**未使用**/
<template>
  <div class="unused" ref="unused">
    <div v-if="couponsFn.length>0" class="unusedContent" ref="Content" :class="addStateBut?'unusedContentFixe':''">
      <xk-couponMod v-for="(item, index) in couponsFn"
        :type="item.type"
        :sum="item.sum"
        :title="item.title"
        :startTime="item.startTime"
        :key="index"
        :endTime="item.endTime"
        :overdueTime="item.overdueTime"
        :useState="1"
        :couponType="item.couponType"
        :serviceType="item.servicetype">
      </xk-couponMod>
    </div>
    <div v-else class="wuyouhuiquan">
      <h2>暂无优惠券</h2>
    </div>
    <div class="addCoupon" :class="addStateBut?'fixe':''" @click="addCouponFn">
      <span>添加优惠券</span>
    </div>
    <xk-input-box v-if="addState" @click="addCouponFn" :title="'添加优惠券'" :closeState="true">
      <div slot="content">
        <input placeholder="请输入优惠券编码" v-model="couponNum" @input="couponNumFn"/>
      </div>
    </xk-input-box>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
    <xk-hintBox :time="1500" v-if="hintBox.stateShow"
      :state="hintBox.state"
      :content="hintBox.content"></xk-hintBox>
  </div>
</template>

<script>
  import Toucth from '../../../assets/js/method'
  import XkCouponMod from '../../module/couponMod/src/couponMod'
  import XkInputBox from '../../module/inputBox/src/inputBox'
  import {mapGetters} from 'vuex'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod'
  import XkHintBox from '../../module/hintBox/src/hintBox'
  import cookieJS from 'js-cookie'
  import JSONBig from 'json-bigint-xk'

  export default {
    components: {
      XkHintBox,
      XkUploadMod,
      XkInputBox,
      XkCouponMod
    },
    name: '',
    computed: {
      ...mapGetters({
        unusedCoupons: 'unusedCoupons',
        loginData: 'loginData'
      }),
      couponsFn: function () {
        let that = this
        let content = that.couponData
        console.log("sssssss", content);


        let list = []
        for (let i = 0; i < content.length; i++) {
          let obj = {
            type: '',
            title: '代驾专享',
            sum: 30,
            startTime: '2017-03-05',
            endTime: '2017-06-06',
            overdueTime: '2',
            couponType: '',
            servicetype: ''
          }
          let date = new Date()
          let SZdate = new Date(content[i].end_time * 1000)
          obj.title = content[i].title
          obj.startTime = Toucth.TimestampDate(content[i].begin_time).split(' ')[0]
          obj.endTime = Toucth.TimestampDate(content[i].end_time).split(' ')[0] !== '1970-01-01' ? Toucth.TimestampDate(content[i].end_time).split(' ')[0] : '永久有效'
          obj.sum = content[i].deductible ? content[i].deductible.toFixed(1) : content[i].discount
          if (content[i].discount) {
            obj.couponType = 'discount'
          } else {
            obj.couponType = 'deduction'
          }
          if (content[i].end_time && Toucth.TimestampDate(content[i].end_time).split(' ')[0] !== '1970-01-01') {
            obj.overdueTime = (SZdate.getFullYear() - date.getFullYear()) > 0 ? (SZdate.getFullYear() - date.getFullYear()) + '年' : (SZdate.getMonth() - date.getMonth()) > 0 ? ((SZdate.getMonth() - date.getMonth())) + '月' : (SZdate.getDate() - date.getDate()) > 0 ? (SZdate.getDate() - date.getDate()) + '天' : (SZdate.getHours() - date.getHours()) > 0 ? (SZdate.getHours() - date.getHours()) + '时' + (SZdate.getMinutes() - date.getMinutes()) + '分' : (SZdate.getMinutes() - date.getMinutes()) > 0 ? (SZdate.getMinutes() - date.getMinutes()) + '分' : null
          } else {
            obj.overdueTime = '永久有效'
          }
          if (content[i].main_service_type === 'daijia') {
            obj.servicetype = '代驾券'
          }
          list.push(obj)
        }
        return list
      }
    },
    data () {
      return {
        couponData: [],
        addStateBut: false,
        addState: false,
        couponNum: '',
        couponPassword: '',
        separator1: false,
        separator2: false,
        loadState: false,
        page: 1,
        rows: 100,
        hintBox: {
          stateShow: false,
          state: 'yes',
          router: ''
        }
      }
    },
    methods: {
      /**
       * 添加优惠券
       */
      addCouponFn (state) {
        let that = this
        if (!that.addState) {
          that.couponNum = ''
        }
        let cookieAppKey = cookieJS.get('cookieAppKey') ? cookieJS.get('cookieAppKey') : null
        that.addState = true
        let appKey = this.$Cookie.get('cookieAppKey')
        let passengerkey = 'passenger' + appKey
        let passenger = this.$Cookie.get(passengerkey) ? JSONBig.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerkey))) : null
        let coupon_id = that.couponNum
        let couponId = parseInt(coupon_id.slice(-6))
        let ruleNo = coupon_id.split(coupon_id.slice(-6))[0]
        if (state === 'affirm') {
          let content = ''
          if (that.couponNum === '') {
            content = '优惠券号不能为空！'
          }
          if (that.couponNum === '') {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: content,
              router: null
            }
            setTimeout(function () {
              that.hintBox.stateShow = false
            }, 1500)
            return
          }
          if (couponId === 0 || isNaN(couponId)) {
            content = '请输入正确的优惠券编码！'
          }
          if (couponId === 0 || isNaN(couponId)) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: content,
              router: null
            }
            setTimeout(function () {
              that.hintBox.stateShow = false
            }, 1500)
            return
          }
          if (!ruleNo) {
            content = '请输入正确的优惠券编码！'
          }
          if (!ruleNo) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: content,
              router: null
            }
            setTimeout(function () {
              that.hintBox.stateShow = false
            }, 1500)
            return
          }
          that.loadState = true
          that.$store.dispatch('addCoupon', {
            'passenger_id': passenger && passenger.passenger && passenger.passenger.id ? passenger.passenger.id : '',
            'rule_id': couponId,
            'num': 1,
            'rule_no': ruleNo,
            'channel': 5,
            'app_key': cookieAppKey,
            fn: (data) => {
              that.loadState = false
              let content = ''
              let router = ''
              let state = ''
              if (data && data.code === 1) {
                content = '添加成功！'
                state = 'yes'
              } else if(data.code === 110521) {content = `优惠卷编码有误`;state = 'no'}
              else if(data.code === 110402) {content = `优惠卷规则已失效`;state = 'no'}
              else if(data.code === 110501) {content = `优惠卷单人领取数量达上限`;state = 'no'}
              else if(data.code === 110502) {content = `优惠卷总数领取数量达上限`;state = 'no'}
              else if(data.code === 110503) {content = `优惠卷已使用`;state = 'no'}
              else if(data.code === 110504) {content = `优惠卷已失效`;state = 'no'}
              else if(data.code === 110505) {content = `优惠卷没在时间范围`;state = 'no'}
              else if(data.code === 110506) {content = `优惠卷不在渠道范围`;state = 'no'}
              else if(data.code === 110507) {content = `优惠券已过期`;state = 'no'}
              else if(data.code === 110520) {content = `赠送的优惠卷数量达上限`;state = 'no'}
              else {content = `优惠券添加失败`;state = 'no'}
              that.hintBox = {
                stateShow: true,
                state: state,
                content: content,
                router: router
              }
              that.queryCouponsFn()
              setTimeout(function () {
                that.hintBox.stateShow = false
                that.addState = false
                if (that.$route.query.addState) {
                  window.history.go(-1)
                }
              }, 1500)
            }
          })
        }
        if (state === 'cancel') {
          that.addState = false
          if (that.$route.query.addState) {
            window.history.go(-1)
          }
        }
      },

      couponNumFn (e) { // 优惠券号
        let val = e.target.value
        this.couponNum = val.toUpperCase()
      },
      queryCouponsFn () {
        let that = this
        that.$store.dispatch('checkLogin', (state) => {
          if (state) {
            that.$store.dispatch('v5getCoupons', {
              channel: 5,
              page: 1,
              limit: 80,
              is_invalid: 2,
              state: 1,
              'fn': (data) => {
                that.loadState = false
                if (data && data.code === 1) {
                  let arr = []
                  data.coupon.forEach(item => {
                    if (item.state === 1) {
                      var endTime = item.expire_time
                      if (endTime) {
                        if (new Date().valueOf() < endTime * 1000) {
                          arr.push(item)
                        }
                      } else {
                        arr.push(item)
                      }
                    }
                  })
                  that.couponData = arr
                } else {
                  that.hintBox = {
                    stateShow: true,
                    state: 'no',
                    content: data.msg
                  }
                }
              }
            })
          }
        })
      }
    },
    mounted: function () {
      let that = this
      // that.loadState = true
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.queryCouponsFn()
          if (that.$route.query.addState) {
            that.addCouponFn()
          }
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .unused {
    box-sizing: border-box;
    padding: 0 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    .unusedContent {
      padding-bottom: 4rem;
    }
    .unusedContentFixe {
      margin-bottom: 1rem;
    }
    .wuyouhuiquan {
      padding-top: 30vh;
      min-height: 40vh;
      h2 {
        text-align: center;
      }
    }
    .addCoupon {
      width: 100%;
      box-sizing: border-box;
      margin-top: -1rem;
      text-align: center;
      background-color: #f3f4f5;
      padding-top: 1.5rem;
      margin-bottom: 1rem;
      span {
        width: 100%;
        height: 3rem;
        line-height: 2.8333rem;
        font-size: 1.25rem;
        border-radius: 0.333rem;
        background: #f06553;
        color: #fff;
      }

    }
    .fixe {
      position: fixed;
      width: 100%;
      padding-bottom: 1rem;
      padding-top: 0;
      bottom: 0;
      left: 0;
      span {
        width: calc(~'100% - 2rem');
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      }
    }
    .inputBoxContent {
      input {
        box-sizing: border-box;
        width: 100%;
        line-height: 2.5rem;
        border: none;
        padding: 0 0.5rem;
        border-bottom: 1px solid #eee;
        font-size: 1.25rem;
        margin: 0.5rem 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// unused.vue?a9b457ce